import { render, staticRenderFns } from "./PermissionPackageViewModal.vue?vue&type=template&id=e9122802&"
import script from "./PermissionPackageViewModal.vue?vue&type=script&lang=js&"
export * from "./PermissionPackageViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports